<template>
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="31" fill="white" stroke="#B4B5B7" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32.3014 22.7646C32.2123 26.7187 30.132 30 27.305 30C24.415 30 22.3043 26.5708 22.3043 22.5C22.3043 18.4292 24.415 15 27.305 15C30.132 15 32.2123 18.2814 32.3014 22.2354L32.3043 22.5L32.3014 22.7646ZM30.3008 22.2354C30.2202 19.2572 28.7891 17 27.305 17C25.7768 17 24.3043 19.3923 24.3043 22.5C24.3043 25.6077 25.7768 28 27.305 28C28.7891 28 30.2202 25.7429 30.3008 22.7646L30.3043 22.5L30.3008 22.2354Z"
      fill="#8A8A8F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.4994 39C22.0124 39 23.9034 36.3888 23.9964 33.243L24 33L23.9964 32.757C23.9034 29.6113 22.0123 27 19.4994 27C16.9221 27 15 29.7467 15 33C15 36.2534 16.922 39 19.4994 39ZM19.4994 29C20.7455 29 21.9191 30.617 21.996 32.7749L22 33L21.996 33.2251C21.9191 35.3831 20.7455 37 19.4994 37C18.2106 37 17 35.27 17 33C17 30.73 18.2107 29 19.4994 29Z"
      fill="#8A8A8F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.5043 47.2714C18.5421 43.0174 26.1442 30.1931 31.8224 30.1931C37.5431 30.1931 45.141 42.9374 41.1045 47.27C39.8585 48.6078 38.3902 49.1082 36.6656 48.9789C35.9244 48.9232 35.2924 48.7879 34.1599 48.4848L33.6878 48.3599C32.8221 48.1344 32.403 48.0514 31.9875 48.04L31.5975 48.0397C31.2358 48.0494 30.8515 48.1217 30.0938 48.316L28.9226 48.6236C28.1035 48.8318 27.5615 48.9337 26.9436 48.9801C25.2188 49.1097 23.7503 48.6094 22.5043 47.2714ZM39.641 45.9068C42.3685 42.9792 35.938 32.1931 31.8224 32.1931C27.7518 32.1931 21.3119 43.0568 23.9679 45.9083C24.7756 46.7757 25.6454 47.072 26.7937 46.9857C27.2768 46.9494 27.7339 46.8627 28.4612 46.6771L29.2014 46.4819C30.4076 46.1622 30.945 46.0491 31.5245 46.0389L31.7775 46.0406C32.4277 46.0231 32.8982 46.094 33.9296 46.3566L35.1482 46.6763C35.8754 46.8616 36.3322 46.9482 36.8152 46.9845C37.9635 47.0706 38.8332 46.7742 39.641 45.9068Z"
      fill="#8A8A8F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M44.805 40C47.318 40 49.2078 37.3891 49.3008 34.2423L49.3043 33.9993L49.3008 33.7563C49.2078 30.6107 47.3178 28 44.805 28C42.2276 28 40.3043 30.7465 40.3043 33.9993C40.3043 37.2532 42.2274 40 44.805 40ZM44.805 30C46.0508 30 47.2236 31.6163 47.3004 33.7742L47.3043 33.9993L47.3004 34.2245C47.2236 36.3836 46.0509 38 44.805 38C43.5157 38 42.3043 36.2697 42.3043 33.9993C42.3043 31.73 43.5158 30 44.805 30Z"
      fill="#8A8A8F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M43.3014 22.7646C43.2122 26.7184 41.1309 30 38.3037 30C35.4139 30 33.3043 26.5712 33.3043 22.5C33.3043 18.4288 35.4139 15 38.3037 15C41.1308 15 43.2122 18.2817 43.3014 22.2355L43.3043 22.5L43.3014 22.7646ZM41.3008 22.2354C41.2202 19.2576 39.7882 17 38.3037 17C36.7759 17 35.3043 19.3919 35.3043 22.5C35.3043 25.6081 36.776 28 38.3037 28C39.7882 28 41.2202 25.7425 41.3008 22.7646L41.3043 22.5L41.3008 22.2354Z"
      fill="#8A8A8F"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'ComfortableWithPets',
};
</script>
